import { TOPBAR_HEIGHT } from '@capsicum/common-web';
import { HeaderWarning } from '@capsicum/features/regulations/web';
import styled from 'styled-components';

export const PageWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	padding: ${({ theme }) => theme.spacings.xlarge} ${({ theme }) => theme.spacings.medium}
		${({ theme }) => theme.spacings.xsmall} ${({ theme }) => theme.spacings.medium};
	row-gap: ${({ theme }) => theme.spacings.xlarge};
	margin-bottom: ${({ theme }) => theme.spacings.xxxlarge};
`;

export const SectionWrapper = styled.section`
	display: flex;
	flex-direction: column;
	width: 100%;
	row-gap: ${({ theme }) => theme.spacings.xsmall};
`;

export const SectionHeader = styled.div`
	display: flex;
	width: 100%;
	justify-content: space-between;
	align-items: center;
`;

export const SectionTitle = styled.span`
	${({ theme }) => theme.fonts.headings.title5};
	color: ${({ theme }) => theme.colors.text.main.enabled};
`;

export const SectionSubtitle = styled.span`
	${({ theme }) => theme.fonts.headings.title6};
	color: ${({ theme }) => theme.colors.text.main.enabled};
`;

export const SectionCardListWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	row-gap: ${({ theme }) => theme.spacings.xsmall};
	color: ${({ theme }) => theme.colors.text.main.enabled};
`;

export const SummarySectionWrapper = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	column-gap: ${({ theme }) => theme.spacings.xsmall};
`;

export const WalletDetailsHeaderWarning = styled(HeaderWarning)`
	top: ${TOPBAR_HEIGHT}px;
`;
